import { EventEmitter } from "./eventEmitter";
import { zenSigleton } from "./zenSingleton";
zenSigleton.regist('urlChangeEvent', new EventEmitter());
var emitter = zenSigleton.get('urlChangeEvent');
export var borwserHistory = {
  push: function push(path, state) {
    emitter.emit('urlChangeEmitter', {
      path: path,
      state: state,
      type: 'pushState'
    });
    history.pushState(state, '', path);
  },
  replace: function replace(path, state) {
    emitter.emit('urlChangeEmitter', {
      path: path,
      state: state,
      type: 'replaceState'
    });
    history.replaceState(state, '', path);
  },
  go: function go(n) {
    return history.go(n);
  },
  goBack: function goBack() {
    return history.back();
  },
  forward: function forward() {
    return history.forward();
  },
  onChange: function onChange(cb) {
    emitter.on('urlChangeEmitter', cb);
  }
};